import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Image, ScrollView, StyleSheet, Text, TouchableOpacity, View, Modal, Button} from "react-native";
import ChevronDroitMediumPicto from "../Picto/ChevronDroitMediumPicto";
import CheckActivePicto from "../Picto/CheckActivePicto";
import {ActivityIndicator} from "react-native";

import { preloadSw } from "../../sw/setup";

import { sw_api } from "../../sw/helpers";

/*

1.

2.

3.

4.


*/

/*
const sw_api = {
  getVersion() { return Promise.resolve({ payload: {version : "3" }}) },
  storageUsage() { return Promise.resolve({ payload: {usage: 5, quota: 15 }}) },
  deleteAllCache() { return Promise.resolve({ payload: true }) },
  deletePrecache() { return Promise.resolve({ payload: true }) }
};
*/


// delete precache not available


class ReglageCacheScreen extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
          modal: false,
          version: null,
          usage: null,
          delete_dynamic_cache_pending: false,
          fill_cache_pending: false
        }

      this.getVersion();
      this.storageUsage();

      this.getVersion = this.getVersion.bind(this);
      this.storageUsage = this.storageUsage.bind(this);
      this.deleteDynamicCache = this.deleteDynamicCache.bind(this);
      this.deletePrecache = this.deletePrecache.bind(this);
      this.reload = this.reload.bind(this);
      this.fillCache = this.fillCache.bind(this);
      this.wrapInModal = this.wrapInModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
      this._setHeader();
    }

    componentDidUpdate() {
      this._setHeader();
    }

    wrapInModal(cb, type) {
      return () => {
        this.setState({ modal: {cb, type} })
      }
    }

    closeModal() {
      this.setState({ modal: null })
    }

    getVersion() {
      sw_api.getVersion().then(x => {
        const { version, time_installed, time_activated } = x.payload
        console.log("VERSION: " + version);
        this.setState(() => ({ version: { version } }));
      })
    }

    storageUsage() {
      sw_api.storageUsage().then(x => {
        const { usage, quota } = x.payload;

        // bytes
        const usage_mb = (usage / 1024 / 1024).toFixed(2);
        const quota_mb = (quota / 1024 / 1024).toFixed(2);
        const percent = (usage/quota).toFixed(2);

        this.setState(() => {
          return {usage: { usage: usage_mb, quota: quota_mb, percent }}
        });
      })
    }

    deleteDynamicCache() {
      this.setState({ delete_dynamic_cache_pending: true })
      return sw_api.deleteAllCache().then(x => {
        this.setState({ delete_dynamic_cache_pending: false })
        console.log("DELETED SUCCESSFULLY ALLCACHE (but precache)");
        this.storageUsage();
      })
    }

    fillCache() {
      this.setState({ fill_cache_pending: true })
      return Promise.all(preloadSw()).then(x => {
        this.setState({ fill_cache_pending: false })
        this.storageUsage();
      })
    }

    deletePrecache() {
      return sw_api.deletePrecache().then(x => {
        console.log("DELETED SUCCESSFULLY PRECACHE");
      })
    }

    reload() {
      window.location.reload();
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize'},
                title : this.props.t('Cache'),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    render() {
        const styles= StyleSheet.create({
            container:{
                paddingVertical:12,
                paddingHorizontal:20,
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value,
                backgroundColor:this.props.theme.colors.primary.White.value
            },
            container2:{
                backgroundColor:"red",
                justifyContent:"flex-end",
            },
            modal:{
                justifyContent:"flex-end",
            },
            container_title:{
                backgroundColor:this.props.theme.colors.primary.blue5.value,
                color:this.props.theme.colors.primary.blue1.value
            },
            text:{
                fontFamily:this.props.theme.fonts.text_bold,
                color : this.props.theme.colors.tertiary.black3.value,
                fontSize:15,
                fontWeight:500
            },
            text_title:{
                color:this.props.theme.colors.primary.blue1.value
            },
            text_value: {
              color: this.props.theme.colors.secondary.orange1.value
            },
            picto:{
                width:10,
                marginRight:10
            }
        });

        const {usage, version, modal} = this.state;

        const getModal = () => {
          return <Modal style={styles.modal} transparent={true} animationType={'slide'} visible={true} onRequestClose={this.closeModal}>
            <View style={styles.view}>
                <View>
                    <Text>{ modal.title }</Text>
                    <TouchableOpacity onPress={this.closeModal}>
                        {/* <FermerPicto style={{width:15,height:15}} isHeader={true} /> */}
                        <Button title={"Annuler"} onPress={this.closeModal} />
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>{this.props.setModalVisible(!this.props.modalVisible)}} >
                        <Button title={"Confirmer"} onPress={modal.cb} />
                    </TouchableOpacity>
                </View>
              </View>
          </Modal>
        }


        /* this.wrapInModal(this.fillCache, 'fillcache') */
        return (
          <View>
            { /* modal && getModal() */ }
            <ScrollView>
                <View style={[styles.container,styles.container_title]}>
                    <Text style={[styles.text,styles.text_title]}>{this.props.t("App version")}</Text>
                    <Text style={styles.text_value}>{ __COMMIT_HASH__ }</Text>
                </View>

                <View style={[styles.container,styles.container_title]}>
                    <Text style={[styles.text,styles.text_title]}>{this.props.t("Cache Info")}</Text>
                </View>

                <TouchableOpacity>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Version")}</Text>
                        <Text style={styles.text_value}>
                            { version && version.version }
                        </Text>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Cache usage")}</Text>
                        <Text style={styles.text_value}>{
                            usage && (
                              `${usage.usage} / ${usage.quota} MB (${usage.percent} %)`
                            )
                        }
                        </Text>
                    </View>
                </TouchableOpacity>

                <View style={[styles.container,styles.container_title]}>
                    <Text style={[styles.text,styles.text_title]}>{this.props.t("Cache Management")}</Text>
                </View>

                <TouchableOpacity onPress={this.deleteDynamicCache}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Delete Dynamic cache")}</Text>
                        <View>
                          {
                           this.delete_dynamic_cache_pending
                           ?  <ActivityIndicator size='large' color="#000" />
                           : <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
                          }
                        </View>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={this.fillCache}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Fill dynamic cache")}</Text>
                        <View>
                          {
                           this.fill_cache_pending
                           ?  <ActivityIndicator size='large' color="#000" />
                           : <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
                          }
                        </View>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={this.reload}>
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Reload app")}</Text>
                        <View>
                          <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
                        </View>
                    </View>
                </TouchableOpacity>

            </ScrollView>
          </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ReglageCacheScreen);

